import { RootState } from '../../../rootReducer';
import { IVideoStore } from './interfaces';

const selectVideo = (state: RootState): IVideoStore => state.accounts.video.dashboard;

export const selectProjectVideoUsage = (state: RootState): IVideoStore['usageByProjects'] => {
  const video = selectVideo(state);
  return video.usageByProjects;
};

export const selectTotalVideoUsage = (state: RootState): number => {
  return selectVideo(state).totalVideoUsage;
};

export const selectVideoAllocatedTime = (state: RootState): number => {
  return selectVideo(state).allocatedSeconds;
};

export const selectAccountCurrentTerm = (state: RootState): string => {
  return selectVideo(state).termStartDate;
};

export const selectVideoLoading = (state: RootState): boolean => {
  return selectVideo(state).loading;
};

export const selectTimeRemaining = (state: RootState): number => {
  const { allocatedSeconds, totalVideoUsage } = selectVideo(state);
  return allocatedSeconds - totalVideoUsage;
};

